const changes = [
  {
    type: 'bugfix',
    description:
      'Fixes an issue where the close modal button was not working for Sync Options modal\n',
  },
];

export default changes;
